"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get HrisOAuthCallbackQuery () {
        return HrisOAuthCallbackQuery;
    },
    get HrisOAuthCallbackRequest () {
        return HrisOAuthCallbackRequest;
    },
    get HrisOAuthProviderEnum () {
        return HrisOAuthProviderEnum;
    },
    get HrisOAuthProviderParams () {
        return HrisOAuthProviderParams;
    },
    get HrisTenantSubdomain () {
        return HrisTenantSubdomain;
    },
    get InitiateHrisOAuthFlowQuery () {
        return InitiateHrisOAuthFlowQuery;
    },
    get InitiateHrisSignInQuery () {
        return InitiateHrisSignInQuery;
    }
});
const _zod = require("zod");
const _models = require("@performyard/models");
const HrisOAuthProviderEnum = _zod.z.enum(_models.HRIS_OAUTH_PROVIDERS);
const HrisOAuthProviderParams = _zod.z.object({
    provider: HrisOAuthProviderEnum
});
const HrisTenantSubdomain = _zod.z.string().min(1).max(63).regex(/^[a-z0-9]([a-z0-9-]*[a-z0-9])?$/i, "Must be a valid subdomain");
const InitiateHrisOAuthFlowQuery = _zod.z.object({
    subdomain: HrisTenantSubdomain,
    /** Only the admin-initiated intents; `sso` has its own route, authenticated differently. */ intent: _zod.z.enum(_models.HRIS_OAUTH_CONNECT_INTENTS)
});
const InitiateHrisSignInQuery = _zod.z.object({
    subdomain: HrisTenantSubdomain
});
const HrisOAuthCallbackRequest = _zod.z.object({
    /** The encrypted state minted at initiate; carries the acting company, user and intent. */ state: _zod.z.string().min(1),
    code: _zod.z.string().min(1),
    // Log attribution only, so the service does not stamp its own caller on every callback. Capped
    // because `userAgent` arrives from a client-controlled header.
    clientIp: _zod.z.string().max(64).optional(),
    userAgent: _zod.z.string().max(512).optional()
});
const HrisOAuthCallbackQuery = _zod.z.object({
    code: _zod.z.string().max(512).optional(),
    state: _zod.z.string().max(4096).optional(),
    error: _zod.z.string().max(256).optional()
});
